import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import Title from "./Title";
import { additionalInfo } from "../../constants/resume";
import List, { Item } from "./List";

const styles = StyleSheet.create({
  details: {
    fontSize: 6,
    fontFamily: "Lato",
  },
  bold: {
    fontFamily: "Lato Bold",
    fontSize: 6,
  },
  container: {
    paddingTop: "4px",
    paddingBottom: "4px",
  },
});

const AdditionalInfo = () => (
  <View style={styles.container}>
    <View>
      <Title>Additional Info</Title>
    </View>
    <List>
      {additionalInfo.map(({ title, content }) => (
        <Item key={title}>
          <Text style={styles.bold}>{title}: </Text>
          <Text style={styles.details}>{content}</Text>
        </Item>
      ))}
    </List>
  </View>
);

export default AdditionalInfo;
